module.exports = __webpack_public_path__ + "media/bootstrap-icons/layers-474a4c9f.svg";